import styles from "./index.module.css";
import React, { useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

export function TagMonsterChild({
  children,
  backgroundColor = "#ADB7C0",
  color = "white",
  ...props
}) {
  const buttonRef = useRef(null);
  const [fontSize, setFontSize] = useState(14);

  useLayoutEffect(() => {
    const button = buttonRef.current;
    if (!button) return undefined;

    const fitText = () => {
      let nextFontSize = 14;
      button.style.fontSize = `${nextFontSize}px`;

      while (button.scrollWidth > button.clientWidth && nextFontSize > 8) {
        nextFontSize -= 1;
        button.style.fontSize = `${nextFontSize}px`;
      }

      setFontSize((currentFontSize) =>
        currentFontSize === nextFontSize ? currentFontSize : nextFontSize
      );
    };

    fitText();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", fitText);
      return () => window.removeEventListener("resize", fitText);
    }

    const observer = new ResizeObserver(fitText);
    observer.observe(button);
    return () => observer.disconnect();
  }, [children]);

  return (
    <button
      ref={buttonRef}
      style={{ backgroundColor, color, fontSize: `${fontSize}px` }}
      className={styles.col}
      title={typeof children === "string" ? children : undefined}
      {...props}
      disabled={props.disabled || !props.onClick}
    >
      {children}
    </button>
  );
}

TagMonsterChild.propTypes = {
  disabled: PropTypes.bool,

  onClick: PropTypes.func,

  backgroundColor: PropTypes.string,

  color: PropTypes.string,
};
